export default {
  methods: {
    async validate(value = this.Model && this.Model[this.def.name], oldValue, silent=false) {
      let valid = true;
      const rules = this.def.validations && this.def.validations.filter((v) => v.fn || v.enabledCondition);
      if(rules && rules.length){
        for(let rule of rules) {
          const enabled = rule.enabledCondition ? await this.$eval(rule.enabledCondition) : true;
          if ((!enabled || (!value && value !== 0)) && !(rule.preset?.name === "ECore.Def.DefEnums.prvRequired") && this.def.kind !== "TForm")
            continue;
          const error = await this.$call(rule.fn, {value, name: this.def.name, model: this.Model, rule, prop: this.def});
          if (!error || error && !error.valid && error !== true) {
            if(!silent) {
              this.errorMessages = this.$t((error && error.message) || (typeof error === "string" || (error && error.label) || (error && error.resourceKey) ? error : rule.message), {value, name: this.def.name, model: this.Model, rule, prop: this.def, ...rule, ...error,});
            }
            valid = false;
            break;
          }
        }
      }
      if (valid) {
        this.errorMessages = null;
      } else if(this.def.kind === "TForm") {
        await this.$store.dispatch(
          "SHOW_SNACKBAR",
          {errorMessage : this.errorMessages , color : "error"}
        );
        valid = false;
      }
      this.valid = valid;
      return valid;
    }
  }
}